import { RazorImageFallback } from "../../../../../components/razor-reuse";
import { useSelector } from "react-redux";
import { ALL_ICONS } from "../../../../../assets/icons/AllIcons";
import CurrencyText from "../../../../../components/fragment/cur-text/CurrencyText";
import StatusFragment from "../../../../../components/fragment/status/StatusFragment";
import RootState from "../../../../../redux/type";
import { formatTime } from "../../../../../utils/Helper";
import AccordionBox from "../../../../../components/AccordionBox";
import { useOverviewContext } from "../../CustomerSingle";
import { systemRoles } from "../../../../../utils/roles";
import ResubmissionAccord from "./component/ResubmissionAccordion";
import KybAccordion from "./component/KybAccordion";

export const valueClass =
  "text-[#596080] font-medium text-[14px] flex items-center [&_svg]:size-[12px] [&_svg]:mr-[4px]";
export const labelClass = "text-[12px] text-[#758089]";

const BusinessOverview = () => {
  const context = useOverviewContext();

  const { customer } = useSelector((state: RootState) => state.customer); // Customer data
  const { user } = useSelector((state: RootState) => state.auth);

  const companyDetails = [
    { label: "Business Name", value: customer?.business?.business_name || "" },
    {
      label: "Number of Employees",
      value: customer?.business?.number_of_employees || "",
    },
    { label: "Website", value: customer?.business?.website || "" },
    { label: "Phone Number", value: customer?.phone || "" },
    { label: "Email Address", value: customer?.email || "" },
    {
      label: "Country of Incorporation",
      value: customer?.resident_country ? (
        <CurrencyText
          currency={
            customer?.business?.country?.code ||
            customer?.resident_country?.iso_code
          }
          url={
            customer?.business?.country?.flag ||
            customer?.resident_country?.flag_url
          }
          text={
            customer?.business?.country?.name ||
            customer?.resident_country?.name
          }
        />
      ) : (
        "---"
      ),
    },
    { label: "State", value: customer?.business?.address?.state || "" },
    {
      label: "Address",
      value:
        customer?.business?.address?.street ||
        customer?.business?.address?.formattedAddress ||
        "",
    },
    {
      label: "Registration Number",
      value: customer?.business?.registration_number || "",
    },
    {
      label: "Postal Code",
      value: customer?.business?.address?.postCode || "",
    },
    {
      label: "Verification Status",
      value: customer?.verification_status?.replace(/-/g, " "),
    },
    {
      label: "Bridge Status",
      value: (
        <StatusFragment
          text={customer?.bridge_customer_status?.replace(/_/g, " ") || "---"}
          className={""}
        />
      ),
    },
    {
      label: "Current Status",
      value: (
        <StatusFragment
          text={customer?.account_status || "---"}
          className={
            customer?.account_status === "active"
              ? "success"
              : customer?.account_status === "inactive"
                ? "pending"
                : customer?.account_status === "suspended"
                  ? "failed"
                  : ""
          }
        />
      ),
    },
    { label: "Sign Up", value: formatTime(customer?.signed_up) },
  ];

  return (
    <div className="pb-[30px]">
      <div className="four-card-grid-box">
        <AccordionBox title="Company Details">
          <div className="bg-white px-4 py-[30px]">
            <div className="grid-box  border border-[#e6e6e6] rounded-lg w-full">
              {/* title icon end */}
              <div className="flex justify-between items-center">
                {/* profile img start */}
                <div className="profile-img-box">
                  <RazorImageFallback
                    loadSize={45}
                    url={customer?.profile_picture}
                  >
                    <figure className="img-box">
                      {ALL_ICONS?.profile_img}
                    </figure>
                  </RazorImageFallback>
                </div>
                {customer?.account_status && (
                  <>
                    {customer?.account_status === "active" &&
                    user?.permissions?.includes(systemRoles[8]) ? (
                      <button
                        onClick={() => {
                          context?.setStatusModal({
                            visible: true,
                            status: "suspend",
                            reason: "",
                          });
                        }}
                        className="text-[14px] text-primary border border-primary py-[6px] px-[10px] rounded-[8px]"
                      >
                        Suspend Business
                      </button>
                    ) : customer?.account_status === "suspended" &&
                      user?.permissions?.includes(systemRoles[9]) ? (
                      <button
                        onClick={() => {
                          context?.setStatusModal({
                            visible: true,
                            status: "unsuspend",
                            reason: "",
                          });
                        }}
                        className="text-[14px] text-primary border border-primary py-[6px] px-[10px] rounded-[8px]"
                      >
                        Unsuspend Business
                      </button>
                    ) : (
                      ""
                    )}
                  </>
                )}
                {/* profile img end */}
              </div>
              {/* label value wrapper box start */}
              <div className="label-value-wrapper-box">
                {/* label value box start */}
                {companyDetails.map((chi) => (
                  <div key={chi.label} className="label-value-box">
                    <p className="label">{chi.label}:</p>
                    <p className="value">{chi?.value || "---"}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </AccordionBox>

        {/* right wrap start */}
        <div className="right-wrap-box">
          <div className="kyc-wrapper-info-box !pb-[28px]">
            <p className="title">KYB Information</p>
            <div className="bg-white text-primary py-[6px] px-[12px]">
              <p className="text-[12px]">Company Data</p>
            </div>
            <div className="bg-white text-primary py-[6px] px-[12px]">
              <p className="text-[12px]">Company Documents</p>
            </div>
            <div className="bg-white text-primary py-[6px] px-[12px]">
              <p className="text-[12px]">Associated Parties</p>
            </div>
            <div className="bg-white text-primary py-[6px] px-[12px]">
              <p className="text-[12px]">Business Source of Funds</p>
            </div>
          </div>
        </div>
      </div>
      <section className="space-y-[35px]">
        {/* KYB Levels */}
        {user?.permissions?.includes(systemRoles[4]) && (
          <>
            <KybAccordion />
          </>
        )}
        {user?.permissions?.includes(systemRoles[38]) && <ResubmissionAccord />}
        {/* Risk Level */}
        <AccordionBox defaultState={false} svgIcon="caution" title="Risk Level">
          <section className="bg-white min-h-[340px] px-[35px] py-[40px] space-y-[20px]">
            <div className="space-y-[8px]">
              <h5 className="text-[14px] font-medium text-[#596080]">
                Device labels
              </h5>
              {customer?.risk_labels?.device?.length > 0
                ? customer?.risk_labels?.device?.map(
                    (item: string, idx: number) => (
                      <span
                        key={idx}
                        className="text-[12px] w-fit block text-[#A47008] bg-[#FFC0430D] rounded-[4px] px-[10px] py-[5px]"
                      >
                        {item}
                      </span>
                    ),
                  )
                : "---"}
            </div>
            <div className="space-y-[8px]">
              <h5 className="text-[14px] font-medium text-[#596080]">
                Cross Check labels
              </h5>
              {customer?.risk_labels?.crossCheck?.length > 0
                ? customer?.risk_labels?.crossCheck?.map(
                    (item: string, idx: number) => (
                      <p
                        key={idx}
                        className="text-[12px] w-fit text-[#A47008] bg-[#FFC0430D] rounded-[4px] px-[10px] py-[5px]"
                      >
                        {item}
                      </p>
                    ),
                  )
                : "---"}
            </div>
          </section>
        </AccordionBox>
      </section>
    </div>
  );
};

export default BusinessOverview;

const checkSvg = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 3L4.5 8.5L2 6"
      stroke="#596080"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
